import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconCloseComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon>
      <svg
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 18 18 6M6 6l12 12" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  );
};

IconCloseComponent.displayName = 'IconClose';

const IconClose = memo(IconCloseComponent);

export default IconClose;
